/**
 * Contrôleur global de switch produit (partagé entre sections).
 *
 * - Toute cible `[data-product-switch="{handle}"]` (tabs, etc.) change le produit actif.
 * - Tout panneau `[data-product-panel="{handle}"]` est affiché si actif, masqué sinon.
 * - Émet/écoute le CustomEvent `product:switch` (détail: { handle }) — même contrat
 *   que le carousel "Choose your energy". Pose aussi `data-active-product` sur <html>.
 */
(function () {
  function apply(handle) {
    if (!handle) return;
    document.documentElement.setAttribute('data-active-product', handle);
    // Couleur d'accent du produit actif (boutons, base note) → variable globale
    var accentEl = document.querySelector('[data-product-panel="' + handle + '"][data-accent]');
    if (accentEl) {
      var accent = accentEl.getAttribute('data-accent');
      if (accent) document.documentElement.style.setProperty('--product-accent', accent);
      var accentText = accentEl.getAttribute('data-accent-text');
      if (accentText) document.documentElement.style.setProperty('--product-accent-text', accentText);
    }
    document.querySelectorAll('[data-product-panel]').forEach(function (el) {
      var match = el.getAttribute('data-product-panel') === handle;
      el.toggleAttribute('hidden', !match);
      // Recalcule les Swiper du panneau révélé (init en display:none => dimensions à 0)
      if (match) {
        requestAnimationFrame(function () {
          el.querySelectorAll('.swiper').forEach(function (s) {
            if (s.swiper) s.swiper.update();
          });
        });
      }
    });
    document.querySelectorAll('[data-product-switch]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-product-switch') === handle);
    });
  }

  // Clic sur une cible de switch → émet product:switch (le carousel s'y resynchronise)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-product-switch]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-switch');
    if (document.documentElement.getAttribute('data-active-product') === handle) return;
    document.dispatchEvent(new CustomEvent('product:switch', { detail: { handle: handle } }));
  });

  // Réagit à tout switch (carousel ou tabs)
  document.addEventListener('product:switch', function (e) {
    if (e.detail && e.detail.handle) apply(e.detail.handle);
  });

  function init() {
    var handle = document.documentElement.getAttribute('data-active-product');
    if (!handle) {
      var first = document.querySelector('[data-product-panel]');
      if (first) handle = first.getAttribute('data-product-panel');
    }
    if (handle) apply(handle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
